import "core-js/modules/es6.object.assign";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled, { css } from 'styled-components';
import Input from '../../../Atoms/Input/Input';
import { media } from '../../../../theme/shared/size';
import spacing from '../../../../theme/shared/spacing';
import zIndex from '../../../../theme/shared/zIndex';
var Wrapper = styled.div.withConfig({
  displayName: "GivingSelector__Wrapper",
  componentId: "haox9c-0"
})(["border-radius:2rem;padding:4px;display:flex;flex-direction:column;margin:", " 0;", "{flex-direction:row;background:", ";width:450px;margin:", " auto 0;}", "{margin:0 auto;}label{flex-basis:100%;", "{flex-basis:50%;}}"], spacing('md'), media('small'), function (_ref) {
  var theme = _ref.theme;
  return theme.color('blue_light');
}, spacing('md'), media('medium'), media('small'));
var MoneyBox = styled(Input).withConfig({
  displayName: "GivingSelector__MoneyBox",
  componentId: "haox9c-1"
})(["input[aria-label='Give once']{border-radius:2rem;margin-bottom:", ";", "{margin-bottom:0;}}input[aria-label='Give monthly']{border-radius:2rem;}input{border:none;&:active:focus{box-shadow:none;}&:focus{border:none;outline:none;box-shadow:inset 0 0 4px ", ";}width:100%;max-width:100%;font-size:", ";font-weight:bold;min-height:48px;cursor:", ";", "}"], spacing('sm'), media('small'), function (_ref2) {
  var theme = _ref2.theme;
  return theme.color('blue');
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSize('s');
}, function (_ref4) {
  var active = _ref4.active;
  return active === true ? 'default' : 'pointer';
}, function (_ref5) {
  var boxBorderColor = _ref5.boxBorderColor,
      isInputMatchBox = _ref5.isInputMatchBox,
      isSelected = _ref5.isSelected;
  return (boxBorderColor === isInputMatchBox || isSelected) && css(["", ";", ";background-color:", ";color:", ";"], function (_ref6) {
    var active = _ref6.active;
    return active === true ? 'box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);' : null;
  }, function (_ref7) {
    var active = _ref7.active;
    return active === true ? zIndex('low') : null;
  }, function (_ref8) {
    var active = _ref8.active,
        theme = _ref8.theme;
    return active === true ? theme.color('blue') : theme.color('blue_light');
  }, function (_ref9) {
    var active = _ref9.active,
        theme = _ref9.theme;
    return active === true ? theme.color('white') : theme.color('black');
  });
});

var GivingSelector = function GivingSelector(_ref10) {
  var givingType = _ref10.givingType,
      changeGivingType = _ref10.changeGivingType,
      rest = _objectWithoutProperties(_ref10, ["givingType", "changeGivingType"]);

  return React.createElement(Wrapper, null, React.createElement(MoneyBox, Object.assign({}, rest, {
    "aria-label": "Give once",
    value: "Give once",
    type: "button",
    label: "",
    errorMsg: "",
    active: givingType === 'single',
    onClick: function onClick() {
      changeGivingType('single');
    }
  })), React.createElement(MoneyBox, Object.assign({}, rest, {
    "aria-label": "Give monthly",
    value: "Give monthly",
    type: "button",
    label: "",
    errorMsg: "",
    active: givingType === 'monthly',
    onClick: function onClick() {
      changeGivingType('monthly');
    }
  })));
};

export default GivingSelector;